//main.js
import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Router from './routes'
import {
    IntlProvider,
    addLocaleData,
    localeData
} from 'react-intl';
import lang from 'ac-lang-cn'; 
import { Provider } from "react-redux";
import store from "./store";

import zh from 'react-intl/locale-data/zh';
import en from 'react-intl/locale-data/en';
addLocaleData([...en, ...zh]);
import { getLocale }  from 'jscommon/localeUtil.js';
import CSSUtil from 'jscommon/cssUtil.js';
import {getHashQueryString,getCasUrl} from 'jscommon/urlUtil.js';
import TitleUtil from 'jscommon/titleUtil.js';
import {SyncPost,SyncGet} from 'jscommon/ajaxUtil.js'
import authUtil from 'jscommon/authUtil.js';
import Page404 from './Page404.jsx'
import PubSub from "pubsub-js"
import md5 from 'js-md5'
// import sha1 from 'js-sha1'

React.Component.prototype.$md5 = md5
// React.Component.prototype.$sha1 = sha1

window.localStorage.switchLang = '';


/** TODO 临时方案，后期页面改redux */
authUtil.iSYHTLiteVersion();

// if (window.ISYHTLiteVersion) {

    SyncPost('/config/getByKeys', { keys: ['logo', 'logoutUrl', "registerProtocolTitle", "registerProtocolUrl",'privacyAgreementTitle','privacyAgreementUrl'] }, function (result) {
        if (result.flag) {
            window.pswRuleInfo = result.data || {};
            let keyArray = result.extinfo;
            if (keyArray && keyArray.length) {
                for (let i = 0; i < keyArray.length; i++) {
                    let item = keyArray[i];
                    switch (item.key) {
                        case 'logo': {
                            window.YonyouleftlogoSrc = item.value;
                            break;
                        }
                        case 'logoutUrl': {
                            window.YonyouCloudUrl = item.value;
                            break;
                        }
                        case 'registerProtocolTitle': {
                            window.registerProtocolTitle = item.value;
                            break;
                        }
                        case 'registerProtocolUrl': {
                            window.registerProtocolUrl = item.value;
                            break;
                        }
                        case 'privacyAgreementTitle': {
                            window.privacyAgreementTitle = item.value;
                            break;
                        }
                        case 'privacyAgreementUrl': {
                            window.privacyAgreementUrl = item.value;
                            break;
                        }
                        default:
                            break;
                    }
                }
            }
        }
    }, function (xhr, status, err) {});
// }



window.YHTBreadCrumb = [];



class InitComponent extends Component {
    constructor(props) {
        super(props);
        this.updateHandle = this.updateHandle.bind(this);
        this.reloadLang = this.reloadLang.bind(this);
        this.state=this._initialState()
    };
    _initialState() {
        return {
            currentLang: '',
            messages: {},
            errRoute:false
        };
    };

    componentWillMount() {
        //输入错误路由拦截
         const errRoute=this.routeControl()
        //  /\/fe-free\/?$/.test(location.pathname)
         if (errRoute) {
             this.setState({errRoute:true})
         }

        /** 申诉，找回密码，注册页面，不走main组件，需要获取登录地址和cas服务器地址 */
        /** TODO 临时方案，后期页面改redux */
        var sysid = getHashQueryString("sysid");
        getCasUrl();
        SyncGet('/user/queryPageConfig?sysid=' + sysid, true,
            function (result) {
                if (result.status) {
                    var content = result.content;
                    if (content) {
                        content = JSON.parse(content);
                        if (content.Yht_Sso_UnifiedLogin_Getpwdtologin_url) {
                            window.yhtUnifiedLoginUrl = content.Yht_Sso_UnifiedLogin_Getpwdtologin_url;
                        }
                        if (content.Yht_Server_UnifiedGetpwd_Logo) {
                            let cdnhost=window.location.host
                            let cdnUrl='https://cdn.yonyoucloud.com/dev/yht'
                            if (cdnhost.indexOf("euc") != -1) {
                                cdnUrl='https://cdn.yonyoucloud.com/pro/yht'
                            }
                            window.yhtUnifiedGetpwdLogo=`${cdnUrl}${content.Yht_Server_UnifiedGetpwd_Logo}`
                        }
                    }
                }
            }, function (xhr, status, err) {
                window.console && console.error('queryPageConfig error:', status, err.toString());
            });
        this.reloadLang();
    }

    routeControl=()=>{
        let path=window.location.href
        let val ='fe-free/#/usercenter'
        return path.includes(val)
    }

    componentDidMount() {
        PubSub.subscribe('reloadLang', function (topic, value) {
            console.log(98766)
            this.reloadLang();
            this.getCurrentHttp();
        }.bind(this));

        this.getCurrentHttp();
        //判断是否测试日常环境，显示默认验证码
        this.isEnv()
    }

    componentWillUnmount() {
        window.localStorage.switchLang = '';
    }

    isEnv=()=>{
        let href=window.location.host
        let key=['bip-test.yyuap.com','bip-daily.yyuap.com','localhost:3007']
        if (key.includes(href)) window.isEnv=true
    }


    /** 获取配置域名
     *  todo 获取配置请求需要合并*/
    /** TODO 临时方案，后期页面改redux */
    getCurrentHttp() {
        let currentLang = getLocale();
        let _cachePwdRule = window.cachePwdRule || {};
        let pwdRule = (_cachePwdRule ? (_cachePwdRule[currentLang] || {}) : {});
        let localeStr = 'zh_CN' || currentLang;
        // if(!window.cachePwdRule || !Object.keys(window.cachePwdRule).includes(localeStr)) {
            SyncGet('/infoCheck/getBaseInfo', false, (result) => {
                if (result.status) {
                    const retData = result.data;
                    /** apptenantUrl : 租户中心域名地址,
                     * assistUrl:应用开通域名地址
                     * yycloudMarketUrl : 云市场地址,
                     * passwordLockTime : 上锁过期时间 */
                    window.ManagerUrl =  retData.managerUrl || (!window.ISYHTLiteVersion && "http://manager.yyuap.com/yht-manager/")
                    window.assistUrl = retData.assistUrl || (!window.ISYHTLiteVersion && "https://ecos.yonyoucloud.com");
                    window.AppTenantLocationUrl = retData.apptenantUrl || (!window.ISYHTLiteVersion && 'https://apcenter.yonyoucloud.com');
                    window.YonyouCloudUrl = retData.yycloudMarketUrl || (!window.ISYHTLiteVersion && 'http://www.yyuap.com');
                    pwdRule = result.pswRuleInfo;
                    _cachePwdRule[localeStr] = result.pswRuleInfo;
                    window.CasBaseUrl = retData.casurl;

                } else {
                    // window.AppTenantLocationUrl = 'http://uastest.yyuap.com';
                    // window.YonyouCloudUrl = 'http://www.yyuap.com';
                }
            }, (xhr, status, err) => {
                window.console && console.error('queryPageConfig error:', status, err.toString());
            });
        // }
        window.pswRuleInfo = pwdRule;
        window.cachePwdRule = _cachePwdRule;
    }
    updateHandle() {
        CSSUtil.LinkCSSDidClean();
        TitleUtil.changeTitleByPath(window.location.pathname);
    };

    reloadLang() {
        let currentLang = getLocale();
        let _currentMsgMap = window.currentMsgMap || {};
        let messages = (_currentMsgMap ? (_currentMsgMap[currentLang] || {}) : {});
        let localeStr = 'zh_CN' || currentLang;

        if ( !messages.yht　) {
            SyncPost('/config/getUserCenterLang', {
                path: 'js',
                lang: localeStr
            }, false, function (result) {
                let dataObj = result;
                if (dataObj.status === 1) {
                    messages = dataObj.data || {};
                    _currentMsgMap[localeStr] = messages;
                }
            }, function (xhr, status, err) {
                if (window.console) {
                    console.error('query user role', status, err.toString());
                }
            });
        }

        _currentMsgMap[localeStr] = _currentMsgMap[localeStr] || {};
        window.currentMsgMap = _currentMsgMap;
        window.currentMessages = messages;
        this.setState({
            currentLang: currentLang,
            messages: messages
        });
        if (currentLang.toLowerCase().indexOf('en') !== -1) {
            $('body').addClass('en');
        } else {
            $('body').removeClass('en');
        }
    };
    render() {
        let locale = (this.state.currentLang.indexOf('zh') !== -1) ? 'zh' : 'en';
        return (
            this.state.errRoute ? <Page404 /> : <IntlProvider locale={locale} messages={this.state.messages}>
                <Router />
            </IntlProvider>
        );
    }
}


const pack = require('../lang-tool/pack.js') || {};
const initlang = window.location.host.includes('localhost') ? 'https://bip-test.yyuap.com/iuap-apcom-i18n' : "/iuap-apcom-i18n"

lang.init(pack, null);
lang.jsonp(0, 'YS_PF_YHTU', initlang, () => { });

if (module.hot) {
    console.log('实现热更新')
    module.hot.accept(() => {
        ReactDOM.render(
            (
                <Provider store={store}><InitComponent /></Provider>
            ), document.getElementById('content')
        );
    })
}
ReactDOM.render(
    (
        <Provider store={store}><InitComponent /></Provider>
    ), document.getElementById('content')
);
